import { DebounceInput } from 'react-debounce-input';
import SearchIcon from '@mui/icons-material/Search';

export const SearchCity = ({ cityValue, getCiti }) => {
    const handletSubmit = (e) => e.preventDefault();

    return (
        <form className='search' onSubmit={handletSubmit}>
            <DebounceInput
                minLength={2}
                debounceTimeout={600}
                type='text'
                placeholder='Пошук'
                value={cityValue}
                onChange={getCiti}
                className='search-input' />
            <SearchIcon />
        </form>
    )
}